
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#434347","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M15 28l8-8 8 8m-8-6.08V38.4"}}),_c('path',{attrs:{"d":"M4.917 29C2.525 27.147 1 24.342 1 21.202c0-5.49 4.661-9.957 10.468-10.098l.282-.003.004-.265C11.904 5.38 16.657 1 22.5 1c5.937 0 10.75 4.522 10.75 10.1C39.187 11.1 44 15.624 44 21.203c0 3.133-1.518 5.932-3.9 7.785"}})])])
          )
        }
      }
    